import { ComponentDesign } from '@paragon/contract-library';
import { distanceEquals } from '@paragon/geometry-library';

import { useAppSelector } from '../../../../hooks';

export function useJackGirderConnectionLoader() {
  const jackGirderConnections = useAppSelector((state) => state.jackGirderConnections.data);
  return function jackGirderConnectionLoader(componentDesign: ComponentDesign) {
    return Object.values(jackGirderConnections)
      .filter((connection) => connection.girderGuid === componentDesign.guid)
      .toSorted((a, b) => {
        if (distanceEquals(a.xLocation, b.xLocation)) {
          if (a.memberType === b.memberType) {
            return 0;
          }
          return a.memberType === 'BottomChord' ? 1 : -1;
        }
        return a.xLocation - b.xLocation;
      });
  };
}
